/**
 * Permission utilities for frontend
 * Note: This is a simplified version. Full permission checks are done on backend.
 */

const ROLE_PERMISSIONS: Record<string, string[]> = {
  secretary: [
    'MANAGE_USERS',
    'ASSIGN_CASES',  // Phân bổ hồ sơ cho các đội thi
    'VIEW_CASES',
    'SCORE_CASES',
    'VIEW_AI_REPORTS',
    'MONITOR_SYSTEM',
    'CONFIGURE_SYSTEM',
    'VIEW_REPORTS',
    'MANAGE_SCHEDULE',
  ],
  judge: [
    'VIEW_CASES',
    'SCORE_CASES',
    'VIEW_AI_REPORTS',
  ],
  student: [
    'REGISTER_TEAM',  // Đăng ký đội thi trực tuyến
    'MANAGE_TEAM',  // Quản lý thông tin đội
    'VIEW_OWN_CASE',
    'SUBMIT_MEMORIAL',
    'UPLOAD_EVIDENCE',
    'VIEW_TEAM_DASHBOARD',
  ],
  coach: [
    'VIEW_OWN_CASE',
    'VIEW_TEAM_PROGRESS',
    'DOWNLOAD_DOCUMENTS',
    'VIEW_TEAM_DASHBOARD',
  ],
  support: [
    'MANAGE_USERS',
    'VIEW_CASES',
    'MONITOR_SYSTEM',
    'HANDLE_SUPPORT_TICKETS',
    'VIEW_LOGS',
  ],
}

export function hasPermission(role: string, permission: string): boolean {
  const permissions = ROLE_PERMISSIONS[role] || []
  return permissions.includes(permission)
}

export function getPermissionsForRole(role: string): string[] {
  return ROLE_PERMISSIONS[role] || []
}
